import React, { Fragment } from "react";
import { Parallax, /* ParallaxBanner */ } from "react-scroll-parallax";
import { BlockWrapper } from "../Preview";

export default function ParallaxAnimations({ block }: any) {

    /*
        const handleClasses = (classes: any) => {
            const values = classes.split(' ');
            let str = "";

            for (let i = 0; i < values.length; i++) {
                if (!values[i].includes('bg-[url(')) {
                    str += " " + values[i];
                }
            }

            return str.trim();
        }
    */

    // console.log("Block in preview: ", block);

    return (
        <Fragment>
            {/* for normal parallax */}
            {
                block?.data?.isParallax && (
                    <Parallax
                        easing={block?.data?.easing}
                        {...(block?.data?.isChangeTime && { startScroll: block?.data?.changeTime?.start })}
                        {...(block?.data?.isChangeTime && { endScroll: block?.data?.changeTime?.end })}

                        {...(block?.data?.isSpeed && { speed: block?.data?.speed })}

                        {...(block?.data?.isOpacity && { opacity: [block?.data?.opacity?.start, block?.data?.opacity?.end] })}

                        {...(block?.data?.isRotate && { rotate: [block?.data?.rotate?.start, block?.data?.rotate?.end] })}
                        {...(block?.data?.isRotateX && { rotateX: [block?.data?.rotateX?.start, block?.data?.rotateX?.end] })}
                        {...(block?.data?.isRotateY && { rotateY: [block?.data?.rotateY?.start, block?.data?.rotateY?.end] })}
                        {...(block?.data?.isRotateZ && { rotateZ: [block?.data?.rotateZ?.start, block?.data?.rotateZ?.end] })}

                        {...(block?.data?.isScale && { scale: [block?.data?.scale?.start, block?.data?.scale?.end] })}
                        {...(block?.data?.isScaleX && { scaleX: [block?.data?.scaleX?.start, block?.data?.scaleX?.end] })}
                        {...(block?.data?.isScaleY && { scaleY: [block?.data?.scaleY?.start, block?.data?.scaleY?.end] })}
                        {...(block?.data?.isScaleZ && { scaleZ: [block?.data?.scaleZ?.start, block?.data?.scaleZ?.end] })}

                        {...(block?.data?.isTranslateX && { translateX: [block?.data?.translateX?.start, block?.data?.translateX?.end] })}
                        {...(block?.data?.isTranslateY && { translateY: [block?.data?.translateY?.start, block?.data?.translateY?.end] })}
                    >
                        {
                            block?.type != "img" && block?.type != "textarea" && block?.type != "input" ?
                                React.createElement(
                                    block?.type,
                                    {
                                        key: block?.id,
                                        id: block?.id,
                                        style: {
                                            fontFamily: block.style?.fontFamily ? block.style.fontFamily : null,
                                        },
                                        className: `${block?.css == undefined ? "" : `${block?.css}`}`,
                                    },
                                    block?.content,
                                    block?.children && block?.children?.map((childBlock: any) => (
                                        <BlockWrapper
                                            key={childBlock.id}
                                            block={childBlock}
                                        />
                                    ))
                                )
                            :
                                React.createElement(
                                    block?.type,
                                    {
                                        key: block?.id,
                                        id: block?.id,
                                        style: {
                                            fontFamily: block.style?.fontFamily ? block.style.fontFamily : null,
                                        },
                                        className: `${block?.css == undefined ? "" : `${block?.css}`}`,
                                        src: block?.data?.src && block?.data?.src,
                                    }
                                )
                        }
                    </Parallax>
                )
            }

            {/* for image or bg image parallax banner 
                {
                    (block?.data?.isParallaxBanner && (block?.type === 'img' || block?.data?.backgroundImage === true)) && (
                        <ParallaxBanner
                            layers={
                                [
                                    { image: block?.data?.src, speed: -15 },
                                    {
                                        speed: -20,
                                        children: (
                                            <React.Fragment>
                                                {
                                                    <div className="absolute inset-0 flex flex-col items-center justify-center">
                                                        {
                                                            block?.children && block?.children?.map((childBlock: any) => (
                                                                <BlockWrapper
                                                                    key={childBlock.id}
                                                                    block={childBlock}
                                                                />
                                                            ))
                                                        }
                                                    </div>
                                                }
                                            </React.Fragment>
                                        ),
                                    },
                                ]
                            }
                            className={`${handleClasses(block?.css)}`}
                        >
                            {
                                block?.type !== "img" ?
                                    React.createElement(
                                        block?.type,
                                        {
                                            key: block?.id,
                                            id: block?.id,
                                            style: {
                                                fontFamily: block.style?.fontFamily ? block.style.fontFamily : null,
                                            },
                                            className: `${block?.css == undefined ? "" : `${block?.css}`}`,
                                        },
                                        block?.content,
                                    )
                                :
                                    React.createElement(
                                        block?.type,
                                        {
                                            key: block?.id,
                                            id: block?.id,
                                            style: {
                                                fontFamily: block.style?.fontFamily ? block.style.fontFamily : null,
                                            },
                                            className: `${block?.css == undefined ? "" : `${block?.css}`}`,
                                            src: block?.data?.src && block?.data?.src,
                                        }
                                    )
                            }
                        </ParallaxBanner>
                    )
                }
            */}
        </Fragment>
    );
};

